import React, { memo, useMemo } from "react";

export const StatCard = memo(function StatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  accentColor = "hsl(var(--primary))",
}) {
  const iconContainerStyle = useMemo(
    () => ({
      backgroundColor: `${accentColor}20`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }),
    [accentColor]
  );

  const valueStyle = useMemo(() => ({ color: accentColor }), [accentColor]);

  const iconStyleWithColor = useMemo(
    () => ({ width: "20px", height: "20px", color: accentColor }),
    [accentColor]
  );

  return (
    <div
      className="card shadow-sm p-3 stat-card m-3"
      style={{ minWidth: "100px", borderRadius: "12px" }}
    >
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <p className="small text-secondary mb-1">{title}</p>

          <h3 className="fw-bold mb-1" style={valueStyle}>
            {value}
          </h3>

          {subtitle && <p className="small text-secondary mb-1">{subtitle}</p>}

          {trend && <p className="small text-success mt-1 mb-0">{trend}</p>}
        </div>

        <div className="p-2 rounded" style={iconContainerStyle}>
          <Icon style={iconStyleWithColor} />
        </div>
      </div>
    </div>
  );
});
